"use client";

import { motion } from "framer-motion";
import { GALLERY } from "@/lib/marketing/copy";
import { galleryImages } from "@/lib/marketing/images";
import { SectionHeader } from "@/components/common/SectionHeader";

export function GalleryMasonry() {
  const columns = [
    galleryImages.slice(0, 4),
    galleryImages.slice(4, 8),
    galleryImages.slice(8, 12),
  ];

  return (
    <section className="zaklyn-section">
      <div className="zaklyn-container">
        <SectionHeader
          title={GALLERY.title}
          subtitle={GALLERY.subtitle}
        />

        <div className="grid grid-cols-2 md:grid-cols-3 gap-4">
          {columns.map((column, columnIndex) => (
            <div key={columnIndex} className="flex flex-col gap-4">
              {column.map((image, imageIndex) => {
                const heights = ["aspect-[3/4]", "aspect-square", "aspect-[4/5]", "aspect-[3/4]"];
                const aspectClass = heights[imageIndex % heights.length];

                return (
                  <motion.div
                    key={`${columnIndex}-${imageIndex}`}
                    initial={{ opacity: 0, y: 20 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true, margin: "-50px" }}
                    transition={{
                      duration: 0.5,
                      delay: (columnIndex * 4 + imageIndex) * 0.05,
                    }}
                    className={`relative ${aspectClass} rounded-2xl overflow-hidden group`}
                  >
                    <img
                      src={image.src}
                      alt={image.alt}
                      className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
                    />
                    <div className="absolute inset-0 bg-gradient-to-t from-foreground/20 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300" />
                  </motion.div>
                );
              })}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
